(function(){
'use strict';
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var device=$('#device'), site=$('#site'), stage=$('#stage');
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
/* ---------- Shopify mode: the theme prints window.DH (variants, settings, cart, routes). The mockup has none,
   so everything below behaves exactly as before unless DH is set. In the store the page itself scrolls, and the
   cart, menu, sticky bar and pop-ups sit in a second, window-sized frame (#dhLayer). ---------- */
var DH=window.DH&&window.DH.shopify?window.DH:null;
var layer=$('#dhLayer')||device;
/* store asset address: the versioned URL from DH.assets (it changes whenever the file changes, so browsers never
   keep an old photo), else the plain theme asset folder */
function A(p){ if(!DH||!p) return p; var f=String(p).replace(/^assets\/(img|video)\//,'').replace(/\?v=\d+$/,'');
  return (DH.assets&&DH.assets[f])||(DH.asset+f); }
function scTop(){return DH?(window.pageYOffset||document.documentElement.scrollTop||0):site.scrollTop;}
function scTo(top,behavior){(DH?window:site).scrollTo({top:top,behavior:behavior||'auto'});}
var scEvt=DH?window:site, ioRoot=DH?null:site;
function setHTML(sel,h){var e=$(sel);if(e)e.innerHTML=h;}
function setText(sel,t){var e=$(sel);if(e)e.textContent=t;}
var money=function(c){return '$'+(c/100).toFixed(2)};
var store={
  get:function(k,d){try{var v=localStorage.getItem(k);return v==null?d:JSON.parse(v)}catch(e){return d}},
  set:function(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
};

/* ---------- data ---------- */
var OFFERS={
  single:{id:'single',name:'Single',strands:1,price:2499,ship:499,ft:'8.9',note:'One strand, about 8.9 feet. Runs a 6 foot table or trims a window. Shipping is $4.99 per order.'},
  duo:{id:'duo',name:'Duo',strands:2,price:4499,ship:0,ft:'17.7',note:'Two separate strands. About 17.7 feet spread out, or 8.9 feet layered for twice the fullness. Free shipping.'},
  four:{id:'four',name:'Mantel + Stairs Set',strands:4,price:7999,ship:0,ft:'35.4',note:''},
  bows:{id:'bows',name:'Velvet Bow Set',addon:true,strands:0,price:2499,ship:0,ft:'',note:''}
};
/* add-ons: the cart's "Finish the look" row and their own pages (body = the product description in Shopify). In the
   store DH.addons (by handle) sets the variant, price and stock, and an add-on that is not published there stays out
   of the cart row. */
var ADDONS=[
  {key:'bows',handle:'velvet-bow-set',name:'Velvet Bow Set',card:'Velvet Bow Set',sub:'4 oxblood velvet bows &middot; ships separately',price:2499,
   imgs:['assets/img/bows.jpg'],alt:['Four oxblood velvet bows'],
   body:'<p>4 oxblood velvet bows, like the ones in our photos. Ships separately with express shipping.</p>'},
  {key:'lights',handle:'warm-white-fairy-lights',name:'Warm White Fairy Lights, 33 ft',card:'Fairy Lights, 33 ft',sub:'33 ft, 100 warm white lights',price:1799,
   imgs:['assets/img/addon-lights.jpg','assets/img/addon-lights-glow.jpg'],alt:['Warm white fairy lights coiled on cream linen with their battery box','Faux cedar garland on a white brick mantel woven with warm white fairy lights'],
   body:'<p>Tiny warm white lights on a thin silver wire that disappears into the garland. 33 feet with 100 lights, enough to weave through two strands from end to end.</p><ul><li>33 ft, 100 warm white LEDs with a steady glow</li><li>Runs on 3 AA batteries (not included) in a small box you can tuck behind the garland</li><li>Thin, bendable wire that wraps around the branches</li></ul>'},
  {key:'hooks',handle:'gold-mantel-hooks',name:'Gold Mantel Hooks, Set of 6',card:'Mantel Hooks, Set of 6',sub:'6 gold hooks, no nails',price:1999,
   imgs:['assets/img/addon-hooks.jpg','assets/img/addon-hooks-mantel.jpg'],alt:['Six gold mantel hooks on cream linen','Gold mantel hooks holding a faux cedar garland on a wooden mantel'],
   body:'<p>Hang the garland, or your stockings, without nails or tape. The flat top rests on the mantel shelf and the hook hangs down the front.</p><ul><li>Set of 6 hooks in a soft gold finish, with 6 anti-slip pads</li><li>No nails, screws, or adhesive</li><li>About 5.5 in long, with a 2 in top that sits on the mantel</li></ul>'},
  {key:'candles',handle:'flameless-taper-candles',name:'Flameless Taper Candles with Remote, Set of 6',card:'Taper Candles, Set of 6',sub:'6 flameless tapers and a remote',price:2999,
   imgs:['assets/img/addon-candles.jpg','assets/img/addon-candles-table.jpg'],alt:['Six ivory flameless taper candles and a remote on cream linen','Flameless taper candles in brass holders along a faux cedar garland on a dining table'],
   body:'<p>Six ivory LED taper candles with a soft flicker, for the mantel or the table. The look of candlelight with no flame near the garland.</p><ul><li>Set of 6, about 11 in tall</li><li>One remote: on and off, a 2, 4, 6, or 8 hour timer, flicker or steady light, and brightness</li><li>Battery powered, no cords</li><li>Candle holders not included</li></ul>'},
  {key:'wreath',handle:'norfolk-pine-wreath',name:'Norfolk Pine Wreath, 24 in',card:'Pine Wreath, 24 in',sub:'About 24 in across',price:7999,
   imgs:['assets/img/addon-wreath.jpg','assets/img/addon-wreath-door.jpg'],alt:['24 inch faux Norfolk pine wreath with an oxblood velvet bow','Faux Norfolk pine wreath on a sage front door framed by cedar garland'],
   body:'<p>A full faux Norfolk pine wreath to match the garland. Hang it on the front door, above the mantel, or on a mirror.</p><ul><li>About 24 in across</li><li>Soft, realistic Norfolk pine tips with 7 pine cones</li><li>Metal frame inside for a sturdy, round shape</li></ul>'},
  {key:'stems',handle:'norfolk-pine-stems',name:'Norfolk Pine Stems, Set of 12',card:'Pine Stems, Set of 12',sub:'12 stems, about 18 in each',price:2999,
   imgs:['assets/img/addon-stems.jpg','assets/img/addon-stems-vase.jpg'],alt:['Twelve faux Norfolk pine stems tied with an oxblood velvet ribbon','Faux Norfolk pine stems in a white vase on an entryway table'],
   body:'<p>Twelve soft-touch Norfolk pine stems. Put a bunch in a vase by the door, tuck a few into the garland for extra fullness, or use them for a centerpiece.</p><ul><li>12 stems, about 18 in long each</li><li>Bendable stems you can shape</li><li>Vase not included</li></ul>'}
];
ADDONS.forEach(function(a){ var o=OFFERS[a.key]=OFFERS[a.key]||{id:a.key}; o.name=a.name; o.addon=true; o.strands=0; o.price=a.price; o.ship=0; o.img=a.imgs[0]; o.sub=a.sub; });
function addonBy(k){ return ADDONS.filter(function(a){return a.key===k})[0]; }
var GALLERY=[
  {src:'assets/img/pdp-home.jpg',alt:'Bring Christmas Home: one strand of the faux cedar garland laid flat, with a loop at each end',cap:'Bring Christmas home',clear:true},
  {src:'assets/img/pdp-branch.jpg',alt:'Beautiful Down to Every Branch: close-up of the two-tone faux tips on a white mantel',cap:'Every branch up close'},
  {src:'assets/img/pdp-mantel.jpg',alt:'Make Your Mantel the Moment: garland across a white brick mantel with burgundy velvet bows',cap:'On the mantel'},
  {src:'assets/img/pdp-stairs.jpg',alt:'A Warm Welcome Starts Here: garland along a staircase rail with burgundy velvet bows',cap:'On the staircase'},
  {src:'assets/img/pdp-table.jpg',alt:'Set the Scene for Togetherness: garland as a table runner with brass candlesticks',cap:'On the table'},
  {src:'assets/img/pdp-flatlay.jpg',alt:'Naturally Beautiful. Beautifully Simple.: one strand laid flat on linen',cap:'One strand, laid flat'},
  {video:'garland8',src:'assets/video/garland8.jpg',alt:'Garland along a staircase rail with burgundy bows',cap:'On the stairs, in a real home'},
  {src:'assets/img/pdp-size.jpg',alt:'About 8.9 Feet Per Strand: one strand laid out straight, 270 cm or about 8.9 feet, with a loop at each end',cap:'About 8.9 ft per strand'}
];
var UGC=[
  {f:'garland8',cap:'Staircase rail with burgundy bows'},
  {f:'garland6',cap:'The expensive look for less'},
  {f:'garland2',cap:'The full look, straight from the box'},
  {f:'garland7',cap:'Why a fuller garland looks cozier'},
  {f:'garland9',cap:'Two strands for a cozy Christmas look'}
];
var REVIEWS=[
  {n:'Karen M.',loc:'Ohio',r:5,t:'Looks like the magazines',b:'I draped the Duo across my mantel and let the ends hang down each side. It looks like the magazines. My sister asked where I bought it.',tag:'Mantel'},
  {n:'Denise R.',loc:'Texas',r:5,t:'Whole staircase in 15 minutes',b:'Two strands covered my whole staircase rail. I tied a few red bows where it dips and that was it. Took me 15 minutes.',tag:'Staircase'},
  {n:'Linda P.',loc:'North Carolina',r:5,t:'Our Christmas Eve table',b:'We host Christmas Eve for 14 people. I ran one strand down the table with flameless candles. Everyone asked about it.',tag:'Hosting'},
  {n:'Patty S.',loc:'Michigan',r:4,t:'So full when you layer it',b:'I twisted both strands together for the mantel. It is so full. It did take some fluffing when it came out of the box.',tag:'Layered',photo:'assets/img/rev-layer.jpg'},
  {n:'Michelle T.',loc:'Pennsylvania',r:5,t:'The room finally feels done',b:'I spread the four strands around the living room. Mantel, two windows, and the bookcase. The room finally matches the tree.',tag:'Spread out'},
  {n:'Susan W.',loc:'Georgia',r:4,t:'Nice color, ordered more',b:'Nice deep green, not that bright fake green. One Duo was not quite enough for my long mantel, so I ordered a second one.',tag:'Mantel',photo:'assets/img/rev-color.jpg'},
  {n:'Barbara K.',loc:'Illinois',r:5,t:'Easy to hang',b:'The loop at each end made it easy. I used small hooks and it went up in minutes. Shipped faster than I expected.',tag:'Hanging',photo:'assets/img/rev-hang.jpg'},
  {n:'Joanne H.',loc:'Minnesota',r:5,t:'Hosting win',b:'I had family over the next weekend and the mantel was the first thing they noticed. Worth it for the photos alone.',tag:'Hosting'}
];
var FAQ=[
  {q:'How full is it?',a:'Each strand is layered faux cedar with soft, bendable tips. Out of the box, fluff the branches and bend the tips outward. It fills out as you go. For a fuller mantel, twist two strands together.'},
  {q:'How long is each strand?',a:'Each strand is 270 cm, about 8.9 feet. The Duo gives you about 17.7 feet end to end. The Mantel + Stairs Set gives you about 35 feet.'},
  {q:'Does it have lights?',a:'No. The garland is unlit, so you choose the lights. Battery string lights with a timer are an easy add.'},
  {q:'What comes in the box?',a:'Only the garland strands in the set you choose. Ribbon, bells, ornaments, lights, hooks, and candles are not included.'},
  {q:'How do I hang it?',a:'There is a loop at each end. Hang it from small hooks or mantel clips, or tie it to a rail with ribbon. It is light enough for removable hooks.'},
  {q:'How does shipping work?',a:'Every order ships with US express shipping.'},
  {q:'Can I use it outside?',a:'Indoor use is best. A dry, covered entry works too. We have not tested it in rain, sun, or wind.'},
  {q:'Is it safe near candles?',a:'Keep it away from open flames and heat. Use flameless candles near the garland.'},
  {q:'Can I return it?',a:'Yes. You have 30 days from delivery. Opening the box to inspect it is fine. Change-of-mind returns must be clean and resalable, and you cover the return shipping. No restocking fee. Damaged or wrong items are replaced or refunded at our cost.'}
];
var ACC=[
  {t:'Dimensions and details',h:'<ul><li>Length: 270 cm per strand, about 8.9 feet (106 inches).</li><li>Sets: Single (1 strand), Duo (2 strands), Mantel + Stairs Set (4 strands). Every strand is separate.</li><li>Material: soft faux cedar tips on a flexible stem. Fluff the tips outward after unboxing.</li><li>Lights: none. The garland is unlit.</li><li>Hanging: loop at each end.</li><li>Weight: about 11 oz per strand, supplier figure to confirm.</li></ul>'},
  {t:'Care',h:'<ul><li>Fluff the branches when it comes out of the box. Bend the tips outward and shape the drops.</li><li>Dust with a soft cloth or a cool hair dryer on low.</li><li>Keep it away from open flames, heaters, and hot bulbs. Use flameless candles.</li><li>Store it loosely coiled in a dry box between seasons.</li></ul>'},
  {t:'Shipping',h:'<p>Shipping is free on the Duo and the Mantel + Stairs Set. A Single ships for $4.99 per order. Every order ships with US express shipping.</p>'},
  {t:'Returns',h:'<ul><li>30 days from the day your order is delivered.</li><li>Opening the box to inspect the garland is fine.</li><li>Change of mind: return it clean, undamaged, and resalable. You pay return shipping. No restocking fee.</li><li>Damaged, defective, or wrong item: send a photo through our support form and we replace it or refund you at our cost.</li></ul>'}
];

if(DH){
  GALLERY.forEach(function(g){g.src=A(g.src);});
  REVIEWS.forEach(function(r){if(r.photo)r.photo=A(r.photo);});
}

/* ---------- state ---------- */
var cart=DH?[]:store.get('dh_cart',[]); if(!Array.isArray(cart)) cart=[];
cart=cart.filter(function(i){return OFFERS[i.id]&&i.qty>0});
var offer='duo';
var galIndex=0;


/* ---------- stars ---------- */
function starsHtml(r){
  var h='';
  for(var i=1;i<=5;i++){h+='<svg class="'+(i<=Math.round(r)?'':'off')+'"><use href="#i-star"/></svg>'}
  return h;
}
$$('.stars[data-stars]').forEach(function(e){e.innerHTML=starsHtml(parseFloat(e.getAttribute('data-stars')))});

/* ---------- routing ---------- */
var pages={home:$('#page-home'),product:$('#page-product'),addon:$('#page-addon'),shop:$('#page-shop')};
var current=DH?(DH.page==='product'?'product':DH.page==='index'?'home':'page'):'home';
function pageUrl(p){return p==='product'?DH.routes.product:DH.routes.root;}
function showPage(name,keepScroll){
  if(DH) return;
  if(!pages[name]) name='home';
  current=name;
  Object.keys(pages).forEach(function(k){ if(pages[k]) pages[k].hidden=k!==name; });
  device.classList.toggle('on-product',name==='product');
  $$('.pv [data-page]').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-page')===name)});
  if(!keepScroll){scTo(0)}
  closeMenu();
  updateSbar();
  setTimeout(function(){observeReveals();syncVideos();if(mqs)fillMarquees();syncArrows();},30);
}
function route(){
  if(DH){ updateSbar(); setTimeout(function(){observeReveals();syncVideos()},30); return; }
  var h=(location.hash||'').replace('#','');
  if(h.indexOf('addon-')===0&&addonBy(h.slice(6))){ renderAddon(h.slice(6)); showPage('addon'); return; }
  if(h==='shop'){ renderShop(); showPage('shop'); return; }
  showPage(h==='product'?'product':'home');
}
/* shop all (mockup); the store prints the same cards from its products */
function shopCard(href,img,alt,name,price,tag){
  return '<a class="shop-card" href="'+href+'"><span class="shop-img">'+(tag?'<span class="badge shop-badge">'+tag+'</span>':'')+'<img src="'+img+'" alt="'+alt+'" width="700" height="700" loading="lazy"></span>'+
    '<span class="shop-n">'+name+'</span><span class="shop-p">'+price+'</span></a>';
}
function renderShop(){
  setHTML('#shopGrid',shopCard('#product','assets/img/garland-card.jpg','The Holiday Cedar Garland: faux cedar garland with a velvet bow on linen','The Holiday Cedar Garland','From '+money(OFFERS.single.price),'Most popular')+
    ADDONS.map(function(a){ return shopCard('#addon-'+a.key,a.imgs[0],a.alt[0],a.name,money(OFFERS[a.key].price)); }).join(''));
}
function renderLook(){
  setHTML('#lookHome',ADDONS.filter(function(a){ return !a.off&&OFFERS[a.key].available!==false; }).map(function(a){
    return shopCard(addonUrl(a),A(a.imgs[0]),a.alt[0],a.name,money(OFFERS[a.key].price)); }).join(''));
}
$$('a[href="#shop"]').forEach(function(a){a.addEventListener('click',function(){ if(current==='shop') scTo(0,RM?'auto':'smooth'); closeCart(); closeMenu(); })});
function addonUrl(a){ return DH?(DH.routes.root||'/')+'products/'+a.handle:'#addon-'+a.key; }
var adKey='bows';
function renderAddon(k){
  var a=addonBy(k); if(!a) return; adKey=k;
  setText('#lkCrumb',a.name); setText('#lkName',a.name); setText('#lkPrice',money(OFFERS[k].price));
  setHTML('#lkRte',a.body); setHTML('#lkAtcPrice','&middot; '+money(OFFERS[k].price)); $('#lkAtc').setAttribute('data-add',k);
  var m=$('#lkMain'); m.src=a.imgs[0]; m.alt=a.alt[0];
  setHTML('#lkThumbs',a.imgs.length>1?a.imgs.map(function(src,i){ return '<button type="button"'+(i?'':' class="on"')+' data-src="'+src+'" data-alt="'+a.alt[i]+'" aria-label="Photo '+(i+1)+'"><img src="'+src+'" alt=""></button>'; }).join(''):'');
  setHTML('#lkPairFrom','From '+money(OFFERS.single.price)+' &middot; free shipping on the Duo');
}
document.addEventListener('click',function(e){
  var b=e.target.closest('.lk-thumbs button'); if(!b) return;
  var m=$('#lkMain'); m.src=b.getAttribute('data-src'); m.alt=b.getAttribute('data-alt')||'';
  $$('.lk-thumbs button').forEach(function(x){ x.classList.toggle('on',x===b); });
});
if(!DH) window.addEventListener('hashchange',route);
$$('.pv [data-page]').forEach(function(b){b.addEventListener('click',function(){
  var p=b.getAttribute('data-page');
  if(location.hash==='#'+p){showPage(p)} else {location.hash=p}
})});
function scrollToEl(el){
  if(!el) return;
  var top=el.getBoundingClientRect().top-(DH?0:site.getBoundingClientRect().top)+scTop()-($('#hdr').offsetHeight+10);
  scTo(Math.max(0,top),RM?'auto':'smooth');
}
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-go]'); if(!t) return;
  var parts=t.getAttribute('data-go').split(':'); var page=parts[0], anchor=parts[1];
  var go=function(){ var el=document.getElementById(anchor); scrollToEl(el); };
  if(DH&&current!==page){ closeMenu(); location.href=pageUrl(page)+'#'+anchor; return; }
  if(current!==page){
    if(location.hash!=='#'+page){ location.hash=page; } else { showPage(page); }
    setTimeout(go,60);
  } else { go(); }
});
$$('a[href="#home"],a[data-to="home"]').forEach(function(a){a.addEventListener('click',function(e){ if(current==='home'){ if(DH) e.preventDefault(); scTo(0,RM?'auto':'smooth'); } })});
$$('a[href="#product"],a[data-to="product"]').forEach(function(a){a.addEventListener('click',function(e){ if(current==='product'){ if(DH) e.preventDefault(); scTo(0,RM?'auto':'smooth'); } closeCart(); closeMenu(); })});

/* ---------- device toggle ---------- */
function setView(v){
  stage.classList.toggle('mobile',v==='mobile');
  $$('.pv [data-view]').forEach(function(b){b.classList.toggle('on',b.getAttribute('data-view')===v)});
  store.set('dh_view',v);
  setTimeout(function(){updateSbar();observeReveals();syncVideos();if(typeof revApply==='function')revApply();if(mqs)fillMarquees();syncArrows();},60);
}
$$('.pv [data-view]').forEach(function(b){b.addEventListener('click',function(){setView(b.getAttribute('data-view'))})});
if(stage) setView(store.get('dh_view','desktop')==='mobile'?'mobile':'desktop');
/* Apple Pay only where it works: iPhones and iPads (any browser) and Safari on a Mac. Chrome and the rest get Google Pay */
var UA=navigator.userAgent||'', isIOS=/iPhone|iPad|iPod/.test(UA)||(/Macintosh/.test(UA)&&navigator.maxTouchPoints>1);
var isApple=isIOS||(/Macintosh/.test(UA)&&/Safari\//.test(UA)&&!/Chrome|Chromium|CriOS|FxiOS|Firefox|Edg|OPR/.test(UA));
if(!isApple){ device.classList.add('is-android'); layer.classList.add('is-android'); }

/* ---------- mobile menu ---------- */
var mnav=$('#mnav'), menuBtn=$('#menuBtn');
function closeMenu(){ mnav.hidden=true; menuBtn.setAttribute('aria-expanded','false'); }
menuBtn.addEventListener('click',function(){
  var open=mnav.hidden;
  if(open){ var sc=layer.getBoundingClientRect().width/layer.offsetWidth||1; var hb=($('#hdr').getBoundingClientRect().bottom-layer.getBoundingClientRect().top)/sc; mnav.style.top=Math.max(0,hb)+'px'; }
  mnav.hidden=!open; menuBtn.setAttribute('aria-expanded',open?'true':'false');
});
$('#mnavClose').addEventListener('click',closeMenu);
$$('#mnav a, #mnav button[data-go]').forEach(function(a){a.addEventListener('click',closeMenu)});

/* ---------- before / after sliders ---------- */
$$('.ba').forEach(function(ba){
  var r=$('.ba-r',ba);
  var set=function(){ ba.style.setProperty('--pos',r.value+'%'); };
  r.addEventListener('input',set); set();
});

/* ---------- styling tabs + helper ---------- */
$$('.tabs [data-tab]').forEach(function(b){b.addEventListener('click',function(){
  var k=b.getAttribute('data-tab');
  $$('.tabs [data-tab]').forEach(function(x){x.setAttribute('aria-selected',x===b?'true':'false')});
  $$('.tab-media img').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-tab')===k)});
  $$('.tab-p').forEach(function(x){x.classList.toggle('on',x.getAttribute('data-tab')===k)});
})});
var RECNAME={single:'a Single',duo:'the Duo',four:'the Mantel + Stairs Set'};
var RECBTN={single:'Add a Single',duo:'Add the Duo',four:'Add the Mantel + Stairs Set'};
document.addEventListener('click',function(e){
  var c=e.target.closest('.helper .chips button'); if(!c) return;
  var h=c.closest('.helper'); var id=c.getAttribute('data-rec');
  $$('.chips button',h).forEach(function(x){x.classList.toggle('on',x===c)});
  $('.rec-t b',h).textContent='Our pick: '+RECNAME[id];
  $('.rec-t span',h).textContent=c.getAttribute('data-why');
  var btn=$('.rec .btn',h); btn.setAttribute('data-add',id); btn.innerHTML=RECBTN[id]+' &middot; '+money(OFFERS[id].price);
});

/* ---------- video tiles ---------- */
function vidHtml(f,cap,extra){
  return '<figure class="vid ugc '+(extra||'')+'" data-vid="'+f+'"><video muted playsinline loop preload="none" poster="'+A('assets/video/'+f+'.jpg')+'" data-src="'+A('assets/video/'+f+'.mp4')+'" aria-label="'+cap+'"></video>'+
    '</figure>';
}
function renderUGC(el){ if(el) el.innerHTML=UGC.map(function(u){return vidHtml(u.f,u.cap)}).join(''); }
renderUGC($('#ugcHome')); renderUGC($('#ugcPdp'));
var vidIO=null;
function playV(v){ if(!v.getAttribute('src')) v.setAttribute('src',v.getAttribute('data-src')); if(!RM){ var p=v.play(); if(p&&p.catch) p.catch(function(err){ if(err&&err.name==='NotAllowedError') vidBlocked=true; }); } }
/* iPhone Low Power Mode blocks autoplay. A page can't override that, so the first tap or key press
   anywhere starts every clip once (that unlocks it), then pauses the ones not on screen */
var vidBlocked=false, vidUnlockT=0;
function unlockVideos(){
  if(!vidBlocked||RM) return; vidBlocked=false; vidUnlockT=Date.now();
  $$('video').forEach(function(v){
    if(v.closest('.slide')) return;
    if(!v.getAttribute('src')&&v.getAttribute('data-src')) v.setAttribute('src',v.getAttribute('data-src'));
    var p=v.play(); if(p&&p.then) p.then(function(){ if(v.hasAttribute('data-src')&&!v._vis) v.pause(); },function(){ vidBlocked=true; });
  });
}
['touchend','click','keydown'].forEach(function(t){ document.addEventListener(t,unlockVideos,true); });
setTimeout(function(){ if(!RM&&$$('.pill-v video').some(function(v){ return v.paused; })) vidBlocked=true; },1500);
function syncVideos(){
  if(!('IntersectionObserver' in window)) return;
  if(!vidIO){ vidIO=new IntersectionObserver(function(es){ es.forEach(function(e){ var v=e.target; v._vis=e.isIntersecting&&e.intersectionRatio>=0.45; if(v._vis){ playV(v); } else if(!v.paused){ v.pause(); } }); },{root:ioRoot,threshold:[0,0.45,1]}); }
  $$('video[data-src]').forEach(function(v){ if(!v._obs){ v._obs=true; vidIO.observe(v); } });
}
syncVideos();
if(RM) $$('.pill-v video').forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); });
document.addEventListener('click',function(e){
  var b=e.target.closest('.snd');
  if(b){
    var fig=b.closest('.vid'), v=$('video',fig);
    var un=!fig.classList.contains('unmuted');
    $$('.vid').forEach(function(f){ f.classList.remove('unmuted'); var vv=$('video',f); if(vv) vv.muted=true; });
    if(un){ fig.classList.add('unmuted'); v.muted=false; playV(v); }
    return;
  }
  var v2=e.target.closest('.vid video'); if(v2&&!v2.closest('.slide')&&Date.now()-vidUnlockT>800){ if(v2.paused) playV(v2); else v2.pause(); }
});
$$('[data-scroll]').forEach(function(b){b.addEventListener('click',function(){
  var row=document.getElementById(b.getAttribute('data-scroll')); var dir=parseInt(b.getAttribute('data-dir'),10);
  row.scrollBy({left:dir*(row.clientWidth*0.7),behavior:RM?'auto':'smooth'});
})});
/* arrows only when the row really scrolls */
function syncArrows(){ $$('.arrows').forEach(function(a){ var b=a.querySelector('[data-scroll]'), row=b&&document.getElementById(b.getAttribute('data-scroll'));
  if(row) a.classList.toggle('no-scroll',row.scrollWidth<=row.clientWidth+1); }); }
syncArrows(); window.addEventListener('resize',syncArrows); window.addEventListener('load',syncArrows);
if('ResizeObserver' in window){ var arRO=new ResizeObserver(syncArrows); $$('.ugc-row').forEach(function(r){ arRO.observe(r); }); }

/* ---------- reviews ---------- */
function revCard(r,k){
  if(r.video){ return '<article class="rev rev-v card">'+vidHtml(r.video,r.cap,'rev-vid')+'</article>'; }
  return '<article class="rev card" data-tag="'+r.tag+'">'+(r.photo?'<div class="rev-ph"><img src="'+r.photo+'" alt="Customer photo" loading="lazy"></div>':'')+'<div class="rev-i">'+
    '<div class="rev-who"><span class="av c'+(k%3)+'">'+r.n.charAt(0)+'</span><span class="who-t"><b>'+r.n+'</b><span class="vb"><svg><use href="#i-check"/></svg>Verified Buyer &middot; '+r.loc+'</span></span></div>'+
    '<span class="stars">'+starsHtml(r.r)+'</span><div class="rev-t">'+r.t+'</div><p class="rev-b">'+r.b+'</p><span class="tag">'+r.tag+'</span></div></article>';
}
setHTML('#revHome',REVIEWS.slice(0,6).map(revCard).join(''));
setHTML('#revPdp',REVIEWS.filter(function(r){return !r.video}).map(revCard).join(''));
var revFilter='all', revOpen=false;
function revApply(){
  if(!$('#revMore')) return;
  var phone=device.offsetWidth<=760, shown=0;
  $$('#revPdp .rev').forEach(function(c){
    var t=c.getAttribute('data-tag'); var ok=revFilter==='all'||t===revFilter||(revFilter==='Layered'&&t==='Spread out');
    var hide=!ok; if(ok){ shown++; if(phone&&!revOpen&&shown>3) hide=true; }
    c.classList.toggle('hid',hide);
  });
  var total=$$('#revPdp .rev').filter(function(c){var t=c.getAttribute('data-tag');return revFilter==='all'||t===revFilter||(revFilter==='Layered'&&t==='Spread out')}).length;
  $('#revMore').hidden=!(phone&&!revOpen&&total>3);
}
if($('#revChips')) $('#revChips').addEventListener('click',function(e){ var b=e.target.closest('button'); if(!b) return; revFilter=b.getAttribute('data-f'); revOpen=false; $$('#revChips button').forEach(function(x){x.classList.toggle('on',x===b)}); revApply(); });
if($('#revMore')) $('#revMore').addEventListener('click',function(){ revOpen=true; revApply(); });
revApply();

/* ---------- accordions ---------- */
var accId=0;
function accHtml(t,h,open){
  accId++;
  return '<div class="acc'+(open?' open':'')+'"><button type="button" class="acc-h" aria-expanded="'+(open?'true':'false')+'" aria-controls="acc'+accId+'"><span>'+t+'</span><svg class="ic"><use href="#i-chev"/></svg></button>'+
    '<div class="acc-p" id="acc'+accId+'"><div class="acc-b"><div>'+h+'</div></div></div></div>';
}
setHTML('#faqHome','<div>'+FAQ.slice(0,5).map(function(f,i){return accHtml(f.q,'<p>'+f.a+'</p>',i===0)}).join('')+'</div><div>'+FAQ.slice(5).map(function(f){return accHtml(f.q,'<p>'+f.a+'</p>',false)}).join('')+'</div>');
setHTML('#accPdp',ACC.map(function(a,i){return accHtml(a.t,a.h,i===0)}).join('')+accHtml('Questions and answers',FAQ.map(function(f){return '<p><b>'+f.q+'</b><br>'+f.a+'</p>'}).join(''),false));
document.addEventListener('click',function(e){
  var h=e.target.closest('.acc-h'); if(!h) return;
  var acc=h.parentNode; var open=!acc.classList.contains('open');
  acc.classList.toggle('open',open); h.setAttribute('aria-expanded',open?'true':'false');
});

/* ---------- gallery ---------- */
var galTrack=$('#galTrack'), thumbs=$('#thumbs'), galMain=$('#galMain');
var lb=$('#lb'), lbImg=$('#lbImg');
if(galTrack){
galTrack.innerHTML=GALLERY.map(function(g,i){
  if(g.video){ return '<figure class="slide slide-v vid" data-i="'+i+'" data-vid="'+g.video+'"><video muted playsinline loop preload="none" poster="'+A('assets/video/'+g.video+'.jpg')+'" data-src="'+A('assets/video/'+g.video+'.mp4')+'" aria-label="'+g.alt+'"></video></figure>'; }
  return '<figure class="slide'+(i===0?' cur':'')+(g.fit?' fit':'')+'" data-i="'+i+'"><img src="'+g.src+'" alt="'+g.alt+'" loading="'+(i<2?'eager':'lazy')+'">'+(g.dim?'<div class="dim"><i></i><b>270 cm &middot; about 8.9 ft per strand</b></div>':'')+'</figure>';
}).join('');
galMain.classList.toggle('chip-off',!!GALLERY[0].clear);
thumbs.innerHTML=GALLERY.map(function(g,i){return '<button type="button" class="'+(i===0?'on':'')+(g.video?' tv':'')+'" data-i="'+i+'" aria-label="Photo '+(i+1)+': '+g.cap+'"><img src="'+g.src+'" alt=""></button>'}).join('');
syncVideos();
function galSet(i){
  galIndex=(i+GALLERY.length)%GALLERY.length;
  $('#galCount').textContent=(galIndex+1)+' / '+GALLERY.length;
  galMain.classList.toggle('chip-off',!!GALLERY[galIndex].clear);
  $$('#thumbs button').forEach(function(b,k){b.classList.toggle('on',k===galIndex)});
  $$('.slide',galTrack).forEach(function(s,k){s.classList.toggle('cur',k===galIndex)});
  var tb=$$('#thumbs button')[galIndex]; if(tb&&tb.scrollIntoView){ try{ tb.scrollIntoView({block:'nearest',inline:'nearest',behavior:RM?'auto':'smooth'}); }catch(e){} }
}
function galGo(i){
  var n=(i+GALLERY.length)%GALLERY.length;
  galTrack.scrollTo({left:n*galTrack.clientWidth,behavior:RM?'auto':'smooth'});
  galSet(n);
}
var galT;
galTrack.addEventListener('scroll',function(){ clearTimeout(galT); galT=setTimeout(function(){ var n=Math.round(galTrack.scrollLeft/galTrack.clientWidth); if(n!==galIndex) galSet(n); },80); },{passive:true});
$('#galPrev').addEventListener('click',function(){galGo(galIndex-1)});
$('#galNext').addEventListener('click',function(){galGo(galIndex+1)});
thumbs.addEventListener('click',function(e){var b=e.target.closest('button'); if(b) galGo(parseInt(b.getAttribute('data-i'),10))});
function openLb(i){ galIndex=i; var g=GALLERY[i]; lbImg.src=g.src; lbImg.alt=g.alt; lb.classList.remove('z'); lb.hidden=false; $('#lbHint').textContent='Click the photo to zoom. '+(i+1)+' of '+GALLERY.length; }
function closeLb(){ lb.hidden=true; lb.classList.remove('z'); }
galTrack.addEventListener('click',function(e){ if(e.target.closest('.snd')) return; var s=e.target.closest('.slide'); if(!s) return; if(s.classList.contains('slide-v')){ var v=$('video',s); if(v.paused) playV(v); else v.pause(); return; } openLb(parseInt(s.getAttribute('data-i'),10)); });
lbImg.addEventListener('click',function(){ lb.classList.toggle('z'); $('#lbHint').textContent=lb.classList.contains('z')?'Scroll to look around. Click to zoom out.':'Click the photo to zoom. '+(galIndex+1)+' of '+GALLERY.length; });
$('#lbClose').addEventListener('click',closeLb);
$('#lbPrev').addEventListener('click',function(){openLb((galIndex+GALLERY.length-1)%GALLERY.length); galGo(galIndex);});
$('#lbNext').addEventListener('click',function(){openLb((galIndex+1)%GALLERY.length); galGo(galIndex);});
lb.addEventListener('click',function(e){ if(e.target===lb||e.target.classList.contains('lb-s')) closeLb(); });
}

/* ---------- offers ---------- */
function setOffer(id,fromRadio){
  offer=id; store.set('dh_offer',id);
  var o=OFFERS[id];
  if(!fromRadio){ var r=$('#offer-'+id); if(r) r.checked=true; }
  setText('#pEach',money(Math.round(o.price/o.strands)));
  setHTML('#pSub',money(o.price)+' for the '+o.name+' &middot; '+(o.ship?'+ '+money(o.ship)+' shipping':'<span class="free">Free shipping</span>'));
  setHTML('#atcPrice','&middot; '+money(o.price));
  setText('#sbName',o.name);
  setHTML('#sbPrice',money(o.price)+' &middot; '+(o.ship?money(o.ship)+' shipping':'Free shipping'));
  var word={1:'One full strand',2:'Two full strands',4:'Four full strands'}[o.strands];
  var li='<li>'+word+' of faux cedar, about 8.9 feet '+(o.strands>1?'each':'long')+'</li>';
  li+='<li>A small loop on each end, so it is ready to hang</li>';
  if(o.strands>1) li+='<li>Separate strands, so you can spread them out (about '+o.ft+' feet) or twist them together for a fuller look</li>';
  li+='<li>No cords or batteries. Add your own lights if you like.</li>';
  setHTML('#inboxList',li);
  if(DH) syncPayForm();
}
if($('#offers')) $('#offers').addEventListener('change',function(e){ if(e.target.name==='offer') setOffer(e.target.value,true); });
if($('#pickHelp')) $('#pickHelp').addEventListener('click',function(e){ var b=e.target.closest('[data-pick]'); if(!b) return; $$('#pickHelp [data-pick]').forEach(function(x){x.classList.toggle('on',x===b)}); setOffer(b.getAttribute('data-pick')); var h=$('#pickHint'); h.textContent='We picked the '+OFFERS[b.getAttribute('data-pick')].name+'. '+b.getAttribute('data-hint'); h.hidden=false; });

/* ---------- cart ---------- */
var cartEl=$('#cart'), ovl=$('#ovl');
var code=store.get('dh_code','')==='WELCOME10'?'WELCOME10':'';
var SHIP_FEE=DH&&DH.shipFee>=0?DH.shipFee:499, FREE_MIN=DH&&DH.freeMin>0?DH.freeMin:4000, CODE=DH&&DH.code?String(DH.code).toUpperCase():'WELCOME10';
/* package protection: checked by default; in the store it is the cart attribute "protection" (yes|no), and checkout
   charges it through the "+ Package Protection" shipping rates (see the checkout app) */
var PROT_ON=DH&&DH.protection?!!DH.protection.on:true, PROT=DH&&DH.protection&&DH.protection.price>=0?DH.protection.price:499;
var protect=DH?true:store.get('dh_prot','yes')!=='no';
function totals(){
  var sub=0, hasSet=false, n=0, hasG=false;
  cart.forEach(function(i){ sub+=OFFERS[i.id].price*i.qty; n+=i.qty; if(i.id==='duo'||i.id==='four') hasSet=true; if(!OFFERS[i.id].addon) hasG=true; });
  var shipFor=function(net){ return cart.length?(hasSet||net>=FREE_MIN?0:SHIP_FEE):0; };
  if(DH){
    /* the store's own numbers: Shopify's subtotal and order discounts; shipping follows the rates (free with a Duo or a set) */
    var sc=SC||{items_subtotal_price:0,total_price:0,cart_level_discount_applications:[]};
    var dsc=(sc.cart_level_discount_applications||[]).reduce(function(a,d){return a+(d.total_allocated_amount||0)},0);
    var pr=cart.length&&PROT_ON&&protect?PROT:0, ship=shipFor(sc.items_subtotal_price-dsc);
    return {sub:sc.items_subtotal_price,ship:ship,disc:dsc,prot:pr,total:sc.total_price+ship+pr,n:n,hasSet:hasSet,hasG:hasG};
  }
  var disc=code?Math.round(sub*0.10):0, ship=shipFor(sub-disc);
  var prot=cart.length&&PROT_ON&&protect?PROT:0;
  return {sub:sub,ship:ship,disc:disc,prot:prot,total:sub-disc+ship+prot,n:n,hasSet:hasSet,hasG:hasG};
}
function saveCart(){ if(DH) return; store.set('dh_cart',cart); store.set('dh_prot',protect?'yes':'no'); }
var SC=null, cartBusy=false, VID={}, BYV={};
if(DH){
  /* variants by the product's first option: Single, Duo, Mantel + Stairs Set; the bow set is its own product */
  (DH.variants||[]).forEach(function(v){
    var o=String(v.option||'').toLowerCase(), k=/^single/.test(o)?'single':/^duo/.test(o)?'duo':/mantel|stairs|four|4/.test(o)?'four':null;
    if(k&&!VID[k]){ VID[k]=v.id; BYV[v.id]=k; OFFERS[k].price=v.price; OFFERS[k].available=v.available; }
  });
  if(DH.bows&&DH.bows.id){ VID.bows=DH.bows.id; BYV[DH.bows.id]='bows'; OFFERS.bows.price=DH.bows.price; OFFERS.bows.available=DH.bows.available; }
  ADDONS.forEach(function(a){ var d=(DH.addons||{})[a.handle];
    if(d&&d.id){ VID[a.key]=d.id; BYV[d.id]=a.key; OFFERS[a.key].price=d.price; OFFERS[a.key].available=d.available; } else if(!VID[a.key]) a.off=true; });
}
/* the add-on page in the store: its own product (DH.addon) is what Add to Cart and the express buttons buy */
var ADDON_KEY=null;
if(DH&&DH.addon&&DH.addon.id){
  var adm=ADDONS.filter(function(a){return a.handle===DH.addon.handle})[0];
  ADDON_KEY=adm?adm.key:'v'+DH.addon.id;
  if(!OFFERS[ADDON_KEY]) OFFERS[ADDON_KEY]={id:ADDON_KEY,name:DH.addon.title,addon:true,other:true,strands:0,ship:0,img:DH.addon.img};
  VID[ADDON_KEY]=DH.addon.id; BYV[DH.addon.id]=BYV[DH.addon.id]||ADDON_KEY; OFFERS[ADDON_KEY].price=DH.addon.price; OFFERS[ADDON_KEY].available=DH.addon.available;
  if($('#lkAtc')) $('#lkAtc').setAttribute('data-add',ADDON_KEY);
}
/* Cart guard (owner, 2026-10-30): the cart only changes right after a shopper's own tap or key press. Shopify reports
   every cart write (add, update, change, clear) to the pixels as product_added_to_cart, which Meta counts as AddToCart,
   so a write with no tap is a fake add. Such a call is refused and logged; tools/cart-guard/check.js fails on it.
   Every cart write runs through queueCart, which judges the tap when the shopper acts, so a slow request ahead in the
   queue never blocks a real tap. */
var lastTap=0, jobTap=false, cartQ=Promise.resolve();
['pointerdown','touchstart','keydown','click'].forEach(function(t){ document.addEventListener(t,function(e){ if(e.isTrusted) lastTap=Date.now(); },true); });
var CART_WRITE=/\/cart\/(add|update|change|clear)(\.js)?$/;
function tapNow(){ return Date.now()-lastTap<15000; }   /* a real tap in the last 15 s */
/* tapped: judged now unless a handler that chains two writes passes the one it judged when the shopper acted */
function queueCart(job,tapped){
  if(tapped==null) tapped=tapNow();
  var run=cartQ.then(function(){ jobTap=tapped; return job(); });
  cartQ=run.then(function(){ jobTap=false; },function(){ jobTap=false; });
  return run;
}
function api(url,body){
  if(body&&CART_WRITE.test(String(url).split('?')[0])&&!jobTap){
    window.__cartGuardBlocked=(window.__cartGuardBlocked||0)+1;
    console.error('[cart-guard] blocked a cart change that no tap started: '+url);
    return Promise.reject(new Error('cart-guard'));
  }
  return fetch(url,{method:body?'POST':'GET',credentials:'same-origin',headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:body?JSON.stringify(body):undefined})
    .then(function(r){return r.json().catch(function(){return {};}).then(function(j){if(!r.ok) throw new Error(j.description||j.message||'Something went wrong. Please try again.');return j;});});
}
function fromShop(c){
  if(!c||!c.items) return;
  SC=c; cart=[];
  c.items.forEach(function(it){
    var k=BYV[it.variant_id];
    if(!k){ k='v'+it.variant_id; if(!OFFERS[k]) OFFERS[k]={id:k,name:it.product_title,strands:0,price:it.final_price,ship:0,addon:true,other:true,img:it.image}; }
    var ex=cart.filter(function(x){return x.id===k})[0];
    if(ex){ ex.qty+=it.quantity; ex.keys.push(it.key); ex.line+=it.final_line_price; }
    else cart.push({id:k,qty:it.quantity,keys:[it.key],line:it.final_line_price});
  });
  var dc=(c.discount_codes||[]).filter(function(d){return d.applicable})[0];
  code=dc?String(dc.code).toUpperCase():'';
  if(PROT_ON) protect=!(c.attributes&&c.attributes.protection==='no');
}
function protectNow(){   /* only inside a queueCart job */
  if(!DH||!PROT_ON) return Promise.resolve();
  var want=protect?'yes':'no';
  if(SC&&SC.attributes&&SC.attributes.protection===want) return Promise.resolve();
  return api(DH.routes.cart_update+'.js',{attributes:{protection:want}}).then(fromShop);
}
function syncProtectAttr(t){ if(!DH||!PROT_ON) return Promise.resolve(); return queueCart(protectNow,t); }
function refreshShop(){ return api(DH.routes.cart+'.js').then(function(c){ fromShop(c); renderCart(); refreshCartPay(); return c; }); }
function shopUpdate(body,t){
  if(cartBusy) return Promise.reject(new Error('busy'));
  cartBusy=true;
  return queueCart(function(){ return api(DH.routes.cart_update+'.js',body); },t).then(function(c){ cartBusy=false; fromShop(c); renderCart(); refreshCartPay(); return c; },
    function(e){ cartBusy=false; toast(e.message); return refreshShop(); });
}
function addToCart(id,qty,t){
  qty=qty||1;
  if(DH){
    if(cartBusy) return;
    if(!VID[id]||OFFERS[id].available===false){ toast('That set is sold out right now.'); return; }
    cartBusy=true;
    queueCart(function(){ return api(DH.routes.cart_add+'.js',{items:[{id:VID[id],quantity:qty}]}).then(function(){ return api(DH.routes.cart+'.js'); })
      .then(function(c){ fromShop(c); return protectNow().then(function(){ return SC; }); }); },t)
      .then(function(c){ cartBusy=false; fromShop(c); renderCart(); openCart(); refreshCartPay(); if(!RM&&$('#cartBtn').animate){ $('#cartBtn').animate([{transform:'scale(1)'},{transform:'scale(1.25)'},{transform:'scale(1)'}],{duration:360}); } },
        function(e){ cartBusy=false; toast(e.message); });
    return;
  }
  var it=cart.filter(function(i){return i.id===id})[0];
  if(it) it.qty+=qty; else cart.push({id:id,qty:qty});
  saveCart(); renderCart();
  openCart();
  if(!RM&&$('#cartBtn').animate){ $('#cartBtn').animate([{transform:'scale(1)'},{transform:'scale(1.25)'},{transform:'scale(1)'}],{duration:360}); }
}
function setQty(id,q,t){
  if(DH){
    var it=cart.filter(function(i){return i.id===id})[0]; if(!it) return Promise.resolve();
    var up={}; it.keys.forEach(function(k,n){ up[k]=n===0?Math.max(0,q):0; });
    return shopUpdate({updates:up},t);
  }
  cart=cart.map(function(i){ if(i.id===id) i.qty=q; return i; }).filter(function(i){return i.qty>0});
  saveCart(); renderCart();
}
function renderCart(){
  var t=totals();
  $('#cartN').textContent=t.n; $('#cartN').hidden=t.n===0;
  $('#cartCountH').textContent=t.n?'('+t.n+')':'';
  $('#cartItems').innerHTML=cart.map(function(i){
    var o=OFFERS[i.id];
    var head=o.other?'<img src="'+(o.img||'')+'" alt=""><div><div class="ci-n">'+o.name+'</div><div class="ci-s">&nbsp;</div>':o.addon?'<img src="'+A(o.img)+'" alt=""><div><div class="ci-n">'+o.name+'</div><div class="ci-s">'+(o.sub||'&nbsp;')+'</div>':'<img src="'+A('assets/img/closeup.jpg')+'" alt=""><div><div class="ci-n">The Holiday Cedar Garland</div><div class="ci-s">'+o.name+' &middot; '+o.strands+' strand'+(o.strands>1?'s':'')+' &middot; '+money(Math.round(o.price/o.strands))+' each</div>';
    return '<div class="c-item card">'+head+
      '<div class="qty"><button type="button" data-q="-1" data-id="'+i.id+'" aria-label="Decrease">&minus;</button><span>'+i.qty+'</span><button type="button" data-q="1" data-id="'+i.id+'" aria-label="Increase">+</button></div></div>'+
      '<div class="ci-p"><span>'+money(DH?i.line:o.price*i.qty)+'</span><button type="button" class="rm" data-rm="'+i.id+'" aria-label="Remove">&times;</button></div></div>';
  }).join('');
  $('#cartEmpty').hidden=cart.length>0;
  $('#cartUp').hidden=!(t.hasG&&!t.hasSet&&t.ship>0);
  var hasDuo=cart.some(function(i){return i.id==='duo'}), hasFour=cart.some(function(i){return i.id==='four'});
  $('#cartUp2').hidden=!(hasDuo&&!hasFour); $('#up2Diff').textContent=money(OFFERS.four.price-OFFERS.duo.price);
  var look=ADDONS.filter(function(a){ return !a.off&&OFFERS[a.key].available!==false&&!cart.some(function(i){return i.id===a.key}); });
  $('#cartLook').hidden=!cart.length||!look.length;
  $('#cartLookRow').innerHTML=look.map(function(a){
    return '<div class="c-look-c"><a class="c-look-img" href="'+addonUrl(a)+'"><img src="'+A(a.imgs[0])+'" alt="'+a.alt[0]+'" width="112" height="112"></a>'+
      '<span class="c-look-n">'+a.card+'</span><span class="c-look-p">'+money(OFFERS[a.key].price)+'</span>'+
      '<button type="button" class="btn btn-ox" data-add="'+a.key+'" aria-label="Add '+a.name+'">Add</button></div>';
  }).join('');
  $('#tDiscRow').hidden=!t.disc; $('#tDisc').textContent='-'+money(t.disc);
  $('#cartProt').hidden=!cart.length||!PROT_ON; $('#cartProtect').checked=protect; $('#protPrice').textContent=money(PROT);
  $('#tProtRow').hidden=!t.prot; $('#tProt').textContent=money(PROT);
  if(DH){ $('#tDiscRow span').textContent='Discount'+(code?' ('+code+')':''); $('#codeApplied span').innerHTML=code===CODE?CODE+' &middot; 10% off your order':code; }
  $('#codeApplied').hidden=!code; $('#codeForm').hidden=!!code; $('#codeOffer').hidden=!!code||!cart.length;
  $('#cartTot').hidden=cart.length===0; $('#cartXp').hidden=cart.length===0; $('#cartCont').hidden=cart.length===0;
  $('#tSub').textContent=money(t.sub);
  $('#tShip').innerHTML=cart.length?(t.ship?money(t.ship):'<span class="free">Free</span>'):money(0);
  $('#tTot').textContent=money(t.total);
  setHTML('#ckTotal','&middot; '+money(t.total));
  $('#checkoutBtn').disabled=cart.length===0;
  $('#checkoutBtn').style.opacity=cart.length?'1':'.5';
  syncTimer();
}
/* ship-today timer: 10 minutes from the first time this shopper has something in the cart; it keeps its place on reload and hides at zero */
var TIMER_MS=10*60*1000, timerT=null;
function syncTimer(){
  var el=$('#cartTimer'); if(!el) return;
  var start=store.get('dh_timer',0), now=Date.now();
  if(!start&&cart.length){ start=now; store.set('dh_timer',start); }
  var left=start?start+TIMER_MS-now:0;
  el.hidden=!cart.length||left<=0;
  if(el.hidden){ clearInterval(timerT); timerT=null; return; }
  var sec=Math.ceil(left/1000); $('#cartTimerT').textContent=Math.floor(sec/60)+':'+('0'+sec%60).slice(-2);
  if(!timerT) timerT=setInterval(syncTimer,1000);
}
$('#cartItems').addEventListener('click',function(e){
  var q=e.target.closest('[data-q]'); if(q){ var id=q.getAttribute('data-id'); var it=cart.filter(function(i){return i.id===id})[0]; if(it) setQty(id,it.qty+parseInt(q.getAttribute('data-q'),10)); return; }
  var r=e.target.closest('[data-rm]'); if(r){ setQty(r.getAttribute('data-rm'),0); }
});
$('#cartProtect').addEventListener('change',function(e){
  protect=e.target.checked; saveCart(); renderCart();
  if(DH) syncProtectAttr().then(renderCart,function(){});
});
$('#cartUp2Btn').addEventListener('click',function(){
  var d=cart.filter(function(i){return i.id==='duo'})[0]; if(!d) return;
  if(DH){ var t=tapNow(); setQty('duo',d.qty-1,t).then(function(){ addToCart('four',1,t); }); return; }
  setQty('duo',d.qty-1); addToCart('four',1);
});
$('#cartUpBtn').addEventListener('click',function(){
  var s=cart.filter(function(i){return i.id==='single'})[0];
  if(DH){ var t=tapNow(); (s?setQty('single',s.qty-1,t):Promise.resolve()).then(function(){ addToCart('duo',1,t); }); return; }
  if(s){ setQty('single',s.qty-1); }
  addToCart('duo',1);
});
function openCart(hint){ cartEl.classList.add('on'); ovl.classList.add('on'); cartEl.setAttribute('aria-hidden','false'); closeMenu(); if(DH){ walletHint(typeof hint==='string'?hint:null); watchCartPay(); } }
function closeCart(){ cartEl.classList.remove('on'); ovl.classList.remove('on'); cartEl.setAttribute('aria-hidden','true'); }
$('#cartBtn').addEventListener('click',openCart);
$('#cartClose').addEventListener('click',closeCart);
$('#cartCont').addEventListener('click',closeCart);
$('#cartLookRow').addEventListener('click',function(e){ if(e.target.closest('.c-look-img')) closeCart(); });
$('#cartShop').addEventListener('click',closeCart);
ovl.addEventListener('click',closeCart);
document.addEventListener('click',function(e){ var b=e.target.closest('[data-add]'); if(b) addToCart(b.getAttribute('data-add'),1); });
if($('#atcBtn')) $('#atcBtn').addEventListener('click',function(){ addToCart(offer,1); });
$('#sbAdd').addEventListener('click',function(){ addToCart(offer,1); });
$$('[data-express]').forEach(function(b){b.addEventListener('click',function(){
  if(DH){ var w=walletOf(b); if(b.closest('.buy')) expressPdp(w); else expressCart(w); return; }
  if(b.closest('.buy')){ var bk=b.closest('.lk-buy')?adKey:offer, it=cart.filter(function(i){return i.id===bk})[0]; if(!it){ cart.push({id:bk,qty:1}); saveCart(); renderCart(); } }
  openCheckout();
})});
function setCode(c,t){
  if(DH){ return shopUpdate({discount:c},t).then(function(){ var C=String(c||'').toUpperCase();
    /* an empty cart cannot use a code yet; Shopify keeps it and applies it once something is added */
    return !c||code===C||(!!SC&&!SC.item_count&&(SC.discount_codes||[]).some(function(d){return String(d.code).toUpperCase()===C})); }); }
  code=c; store.set('dh_code',c); renderCart(); return Promise.resolve(true);
}
$('#codeForm').addEventListener('submit',function(e){ e.preventDefault(); var v=$('#codeIn').value.trim().toUpperCase();
  if(DH){ if(!v) return; var t=tapNow(); setCode(v,t).then(function(ok){ if(!ok) setCode('',t); $('#codeErr').hidden=!!ok; if(ok) $('#codeIn').value=''; }); return; }
  if(v==='WELCOME10'){ $('#codeErr').hidden=true; $('#codeIn').value=''; setCode('WELCOME10'); } else { $('#codeErr').hidden=false; } });
$('#codeRm').addEventListener('click',function(){ setCode(''); });
$('#codeOfferBtn').addEventListener('click',function(){ setCode(CODE); });

/* ---------- welcome popup (demo: no email is stored or sent) ---------- */
var pop=$('#pop');
function openPop(){ if(code) return; $('#popForm').hidden=false; $('#popDone').hidden=true; pop.hidden=false; store.set('dh_pop',1); }
function closePop(){ pop.hidden=true; }
$('#popClose').addEventListener('click',closePop);
$('#popNo').addEventListener('click',closePop);
pop.addEventListener('click',function(e){ if(e.target===pop) closePop(); });
$('#popForm').addEventListener('submit',function(e){ e.preventDefault();
  if(DH){
    /* signs the shopper up as an email subscriber in Shopify Customers (tags: newsletter, welcome-popup) */
    var fd=new URLSearchParams(); fd.append('form_type','customer'); fd.append('utf8','\u2713');
    fd.append('contact[email]',$('#popEmail').value.trim()); fd.append('contact[tags]','newsletter,welcome-popup');
    fetch(DH.routes.root+'contact',{method:'POST',credentials:'same-origin',body:fd}).catch(function(){});
  }
  $('#popForm').hidden=true; $('#popDone').hidden=false; });
$('#popApply').addEventListener('click',function(){ setCode(CODE); closePop(); toast(CODE+' added. 10% off your order.'); });
if(!store.get('dh_pop',0)){
  var popT=setTimeout(openPop,10000);
  document.addEventListener('mouseleave',function ml(e){ if(e.clientY<=0&&!store.get('dh_pop',0)){ clearTimeout(popT); openPop(); document.removeEventListener('mouseleave',ml); } });
}

/* ---------- toast ---------- */
var toastT;
function toast(msg){ $('#toastMsg').textContent=msg; var t=$('#toast'); t.classList.add('on'); clearTimeout(toastT); toastT=setTimeout(function(){t.classList.remove('on')},3200); }
$('#toastBtn').addEventListener('click',function(){ $('#toast').classList.remove('on'); openCart(); });

/* ---------- demo checkout ---------- */
var ck=$('#ck');
function goCheckout(w){
  if(w==='shop'){ location.href=DH.routes.root+'checkout?payment=shop_pay'; return; }
  var f=$('#dhCheckoutForm'); if(f) f.submit(); else location.href=DH.routes.root+'checkout';
}
function openCheckout(){
  if(!cart.length){ toast('Your cart is empty'); return; }
  if(DH){ syncProtectAttr().then(function(){ goCheckout('checkout'); },function(){ goCheckout('checkout'); }); return; }
  var t=totals();
  $('#ckLines').innerHTML=cart.map(function(i){var o=OFFERS[i.id];return '<div><span>'+o.name+' &times; '+i.qty+'</span><span>'+money(o.price*i.qty)+'</span></div>'}).join('')+
    (t.disc?'<div><span>WELCOME10 (10% off)</span><span>-'+money(t.disc)+'</span></div>':'')+(t.prot?'<div><span>Package protection</span><span>'+money(t.prot)+'</span></div>':'')+'<div><span>Shipping</span><span>'+(t.ship?money(t.ship):'Free')+'</span></div><div class="t"><span>Total</span><span>'+money(t.total)+'</span></div>';
  $('#ckBody').hidden=false; $('#ckDone').hidden=true; ck.hidden=false;
}
function closeCheckout(){ ck.hidden=true; }
$('#checkoutBtn').addEventListener('click',openCheckout);
if(ck){
$('#ckClose').addEventListener('click',closeCheckout);
$('#ckPlace').addEventListener('click',function(){ cart=[]; saveCart(); renderCart(); $('#ckBody').hidden=true; $('#ckDone').hidden=false; });
$('#ckBack').addEventListener('click',function(){ closeCheckout(); closeCart(); });
ck.addEventListener('click',function(e){ if(e.target===ck) closeCheckout(); });
}

/* ---------- keyboard ---------- */
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'){ if(lb&&!lb.hidden) closeLb(); else if(ck&&!ck.hidden) closeCheckout(); else if(cartEl.classList.contains('on')) closeCart(); else closeMenu(); }
  if(lb&&!lb.hidden){ if(e.key==='ArrowRight') $('#lbNext').click(); if(e.key==='ArrowLeft') $('#lbPrev').click(); }
});

/* ---------- sticky mobile bar ---------- */
var atc=$('#atcBtn');
function updateSbar(){
  var show=false;
  if(current==='product'&&atc&&!pages.product.hidden){
    var r=atc.getBoundingClientRect(), d=layer.getBoundingClientRect();
    if(r.height>0){ show=(r.bottom<d.top+70); }
  }
  layer.classList.toggle('show-sbar',show);
}
scEvt.addEventListener('scroll',updateSbar,{passive:true});

/* ---------- scroll reveals ---------- */
var revIO=null;
function observeReveals(){
  var els=$$('.rv:not(.in)');
  if(RM||!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in')}); return; }
  if(!revIO){ revIO=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); revIO.unobserve(e.target); } }); },{root:ioRoot,rootMargin:'0px 0px -6% 0px',threshold:0.05}); }
  els.forEach(function(e){revIO.observe(e)});
}

/* ---------- Shopify wallets (store only) ----------
   Only a tap on Shopify's own wallet button opens a pay sheet. Product page: a hidden buy-now form (#dhPayForm)
   follows the set picked in the buy box, and one copy of Shopify's button per wallet sits on top of each drawn
   express button, taking over once it has drawn, so a tap pays for that one set right on the page. Cart: Shopify's
   own wallet row (sections/dh-cart-pay.liquid), fetched again when the cart changes. Same approach as Foldwell,
   Tidyway, KeepOut and OrbitBlade. */
var WALLETS=DH?(DH.wallets||[]):[];
var LABEL={shop:'Shop Pay',paypal:'PayPal',gpay:'Google Pay',apple:'Apple Pay'};
var WALLET={shop:'shop_pay',paypal:'paypal',gpay:'google_pay',apple:'apple_pay'};
var WALLET_TAG={shop:'shop-pay-wallet-button',paypal:'shopify-paypal-button',gpay:'shopify-google-pay-button',apple:'shopify-apple-pay-button'};
var ANY_WALLET='shop-pay-wallet-button, shopify-paypal-button, shopify-google-pay-button, shopify-apple-pay-button, shopify-amazon-pay-button, shopify-buy-it-now-button';
function walletOf(b){ var c=b.className||''; return /\bxp-shop\b/.test(c)?'shop':/\bxp-pp\b/.test(c)?'paypal':(isApple?'apple':'gpay'); }
var xpBox=null,cartPay=null,payForm=null,baseXp=null,slots=[],buyNow={},extraCfgs=[],slotTimer=0,cartPayTimer=0,cartPayReq=null,hintEl=null,sheetWaiter=null;
if(DH){
  xpBox=$('#cartXp'); if(xpBox){ xpBox.classList.add('c-pay'); $$('.xp-b',xpBox).forEach(function(b){ if(WALLETS.indexOf(walletOf(b))<0) b.hidden=true; }); }
  cartPay=$('#shopify-section-dh-cart-pay'); if(cartPay&&xpBox) xpBox.appendChild(cartPay);
  payForm=$('#dhPayForm'); baseXp=payForm?$('shopify-accelerated-checkout',payForm):null;
  var pdx=$('.buy .xp');
  if(pdx){
    $$('.xp-b',pdx).forEach(function(b){ var w=walletOf(b); if(WALLETS.indexOf(w)<0){ b.hidden=true; return; }
      var slot=document.createElement('div'); slot.className='pay-slot pay-slot-'+w; slot.setAttribute('data-wallet',w); b.parentNode.insertBefore(slot,b); slot.appendChild(b); slots.push(slot); });
    pdx.setAttribute('aria-label','Express checkout');
  }
  try{ extraCfgs=JSON.parse(sessionStorage.getItem('dh-wallet-cfgs')||'[]')||[]; }catch(err){ extraCfgs=[]; }
}
function drawn(el){ return !!(el&&customElements.get(el.tagName.toLowerCase())&&el.offsetHeight>=20); }
function walletEl(w){ var el=cartPay&&WALLET_TAG[w]?$(WALLET_TAG[w],cartPay):null; return el&&typeof el.handleClick==='function'?el:null; }
function cartRow(root){ return (root||cartPay)?$('shopify-accelerated-checkout-cart',root||cartPay):null; }
function rowWallets(row){ try{ return JSON.parse((row&&row.getAttribute('wallet-configs'))||'[]')||[]; }catch(err){ return []; } }
function keepCfgs(list){ (list||[]).forEach(function(c){ if(!c||!c.name) return; extraCfgs=extraCfgs.filter(function(x){return x.name!==c.name}); extraCfgs.push(c); }); try{ sessionStorage.setItem('dh-wallet-cfgs',JSON.stringify(extraCfgs)); }catch(err){} }
function walletCfg(w){ var rec=null; try{ rec=baseXp?JSON.parse(baseXp.getAttribute('recommended')||'null'):null; }catch(err){}
  if(rec&&rec.name===WALLET[w]) return rec;
  return rowWallets(cartRow()).filter(function(c){return c.name===WALLET[w]})[0]||extraCfgs.filter(function(c){return c.name===WALLET[w]})[0]||null; }
function fetchRowCfgs(){ return fetch(DH.routes.root+'?section_id=dh-cart-pay',{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw new Error('wallets'); return r.text(); })
  .then(function(html){ var list=rowWallets(new DOMParser().parseFromString(html,'text/html').querySelector('shopify-accelerated-checkout-cart')); keepCfgs(list); return list; }); }
function pickOk(){ return !!(VID[offer]&&OFFERS[offer].available!==false); }
function setField(name,v){ var f=payForm.elements[name]; if(f&&String(f.value)!==String(v)){ f.value=v; f.dispatchEvent(new Event('change',{bubbles:true})); } }
function syncSlots(){ slots.forEach(function(slot){ var w=slot.getAttribute('data-wallet'), copy=buyNow[w]; slot.classList.toggle('live',!!copy&&drawn($(WALLET_TAG[w],copy))&&pickOk()); }); }
function syncPayForm(){ if(!payForm||!pickOk()){ syncSlots(); return; } setField('id',VID[offer]); setField('quantity',1); syncSlots(); }
function warmWallets(){
  if(!DH||!payForm||!slots.length) return Promise.resolve();
  var need=function(){ return slots.filter(function(sl){ return sl.getClientRects().length&&!walletCfg(sl.getAttribute('data-wallet')); }); };
  if(!need().length) return Promise.resolve();
  /* Never touch the cart here: Shopify reports any cart change (update.js too) as product_added_to_cart, which the
     Meta channel sends as AddToCart (owner, 2026-10-30: fake adds from a page-load warm-up). A wallet that cannot
     draw on an empty cart keeps the drawn button, whose tap adds the pick and opens checkout. */
  return fetchRowCfgs().catch(function(){}).then(function(){ mountBuyNow(); });
}
function waitFor(fn,ms){ return new Promise(function(done){ var end=Date.now()+ms; (function look(){ var v=fn(); if(v||Date.now()>end) done(v||null); else setTimeout(look,60); })(); }); }
function mountBuyNow(){
  if(!baseXp) return;
  slots.forEach(function(slot){ var w=slot.getAttribute('data-wallet');
    if(buyNow[w]===false||(buyNow[w]&&buyNow[w].isConnected)||!slot.getClientRects().length) return;
    var cfg=walletCfg(w); if(!cfg) return;
    var el=document.createElement('shopify-accelerated-checkout');
    Array.prototype.forEach.call(baseXp.attributes,function(a){ el.setAttribute(a.name,a.value); });
    el.setAttribute('recommended',JSON.stringify(cfg)); slot.appendChild(el); buyNow[w]=el; });
  clearInterval(slotTimer); var n=0;
  slotTimer=setInterval(function(){ var waiting=false;
    slots.forEach(function(slot){ var w=slot.getAttribute('data-wallet'), copy=buyNow[w]; if(!copy) return; var got=$(ANY_WALLET,copy);
      if(got&&got.tagName.toLowerCase()!==WALLET_TAG[w]&&drawn(got)){ copy.remove(); buyNow[w]=false; return; }
      if(!drawn($(WALLET_TAG[w],copy))) waiting=true; });
    syncSlots(); if(!waiting||++n>80) clearInterval(slotTimer); },250);
}
function watchCartPay(){ if(!cartPay||!xpBox) return; clearInterval(cartPayTimer);
  var n=0, look=function(){ var ok=$$(ANY_WALLET,cartPay).some(drawn); xpBox.classList.toggle('live',ok); if(ok||++n>60) clearInterval(cartPayTimer); };
  look(); cartPayTimer=setInterval(look,250); }
function refreshCartPay(){
  if(!DH||!cartPay) return Promise.resolve();
  if(cartPayReq) return cartPayReq;
  cartPayReq=fetch(DH.routes.root+'?section_id=dh-cart-pay',{credentials:'same-origin'}).then(function(r){ if(!r.ok) throw new Error('wallets'); return r.text(); })
    .then(function(html){ var fresh=new DOMParser().parseFromString(html,'text/html').getElementById('shopify-section-dh-cart-pay'); if(!fresh) return;
      var now=cartRow(), next=cartRow(fresh), key=function(row){ return row?(row.getAttribute('cart-id')||'')+'|'+rowWallets(row).map(function(c){return c.name}).join(','):''; };
      if(now&&key(now)===key(next)) return;
      cartPay.innerHTML=fresh.innerHTML; xpBox.classList.remove('live'); if(cartEl.classList.contains('on')) watchCartPay(); mountBuyNow(); })
    .catch(function(){}).then(function(){ cartPayReq=null; });
  return cartPayReq;
}
function walletHint(w){ if(!xpBox) return;
  if(!hintEl){ hintEl=document.createElement('p'); hintEl.className='wallet-hint'; hintEl.setAttribute('role','status'); xpBox.insertBefore(hintEl,xpBox.firstChild); }
  hintEl.hidden=!w; if(w){ hintEl.innerHTML='Tap <b>'+LABEL[w]+'</b> below to finish.'; setTimeout(function(){ var sc=$('#cartScroll'); if(sc) sc.scrollTo({top:Math.max(0,hintEl.getBoundingClientRect().top-sc.getBoundingClientRect().top+sc.scrollTop-sc.clientHeight/2),behavior:'smooth'}); },60); } }
if(DH&&window.PaymentRequest&&PaymentRequest.prototype&&PaymentRequest.prototype.show&&!PaymentRequest.prototype.show.dhWatched)(function(){
  var show=PaymentRequest.prototype.show; var watched=function(){ var pr=show.apply(this,arguments), w=sheetWaiter; sheetWaiter=null; if(w) w(pr); return pr; };
  watched.dhWatched=true; PaymentRequest.prototype.show=watched; })();
function watchSheet(ms){ return new Promise(function(done){ var over=false, finish=function(v){ if(!over){ over=true; sheetWaiter=null; done(v); } };
  sheetWaiter=function(pr){ pr.then(function(){finish('open')},function(e){ finish(e&&e.name==='AbortError'&&!/background|preview/i.test(String(e.message||''))?'open':'failed'); }); setTimeout(function(){finish('open')},900); };
  setTimeout(function(){finish('none')},ms); }); }
function expressPdp(w){
  var copy=buyNow[w]?$(WALLET_TAG[w],buyNow[w]):null;
  if(copy&&typeof copy.handleClick==='function'&&pickOk()){ try{ copy.handleClick({preventDefault:function(){}}); return; }catch(err){} }
  if(cartBusy) return;
  if(!VID[offer]||OFFERS[offer].available===false){ toast('That set is sold out right now.'); return; }
  cartBusy=true;
  var landed=queueCart(function(){ return api(DH.routes.cart_add+'.js',{items:[{id:VID[offer],quantity:1}]}).then(function(){ return api(DH.routes.cart+'.js'); }); }).then(function(c){ cartBusy=false; fromShop(c); renderCart(); return c; },function(e){ cartBusy=false; toast(e.message); throw e; });
  if(w==='shop'){ landed.then(function(){ goCheckout('shop'); },function(){}); return; }
  landed.then(function(){ return refreshCartPay(); }).then(function(){
    if(w==='gpay'&&!isApple){
      return waitFor(function(){ return walletEl('gpay'); },2500).then(function(el){
        if(!el){ openCart('gpay'); return; }
        var left=false, onBlur=function(){ left=true; }; window.addEventListener('blur',onBlur); var seen=watchSheet(2500);
        try{ el.handleClick({preventDefault:function(){}}); }catch(err){ window.removeEventListener('blur',onBlur); openCart('gpay'); return; }
        return seen.then(function(r){ window.removeEventListener('blur',onBlur); if(r!=='open'&&!left) openCart('gpay'); }); }); }
    openCart(w); },function(){});
}
var xpGate=Promise.resolve();
function expressCart(w){
  var el=walletEl(w);
  if((w==='apple'||w==='gpay'||w==='shop')&&el&&!cartBusy){
    /* the pay sheet reads the cart: let the protection choice land first */
    xpGate=syncProtectAttr().catch(function(){});
    try{ Promise.resolve(el.dataSource).then(function(ds){ if(!ds||typeof ds.getInitialCart!=='function'||ds.dhHeld) return; var read=ds.getInitialCart.bind(ds);
        ds.getInitialCart=function(){ var a=arguments; return xpGate.then(function(){ return read.apply(null,a); }); }; ds.dhHeld=true; }).catch(function(){});
      el.handleClick({preventDefault:function(){}}); return; }catch(err){}
  }
  syncProtectAttr().then(function(){ goCheckout(w); },function(){ goCheckout(w); });
}

/* ---------- ribbons: repeat the text until one loop is wider than the screen, so a ribbon never runs out ---------- */
function fillMarquee(t){
  if(!t._base){ var kids=Array.prototype.slice.call(t.children); t._base=kids.slice(0,kids.length/2).map(function(k){return k.outerHTML}).join(''); t._dur=parseFloat(getComputedStyle(t).animationDuration)||28; t._k=1; }
  var box=t.parentElement.clientWidth, one=t.scrollWidth/(2*t._k);
  if(!box||!one) return;
  var k=Math.max(1,Math.ceil(box/one));
  if(k===t._k) return;
  var half=new Array(k+1).join(t._base);
  t.innerHTML=half+half; t._k=k; t.style.animationDuration=(t._dur*k)+'s';   /* same speed, just a longer loop */
}
var mqs=$$('.ann-track,.ribbon-t,.trust-t');
function fillMarquees(){ mqs.forEach(fillMarquee); }
fillMarquees(); window.addEventListener('resize',fillMarquees); window.addEventListener('load',fillMarquees);
if('ResizeObserver' in window){ var mqRO=new ResizeObserver(fillMarquees); mqs.forEach(function(t){ mqRO.observe(t.parentElement); }); }

/* ---------- boot ---------- */
if(DH) fromShop(DH.cart);
if(ADDON_KEY) offer=ADDON_KEY; else setOffer(offer);
renderCart();
renderLook();
route();
observeReveals();
if(DH){
  document.documentElement.style.setProperty('--dh-hdr',($('#hdr').offsetHeight+10)+'px');
  mountBuyNow(); syncPayForm(); warmWallets();
  if(DH.page==='cart') openCart();
  if(location.hash&&location.hash.length>1){ var hs=location.hash.slice(1); setTimeout(function(){ var el=document.getElementById(hs); if(el) scrollToEl(el); },150); }
}
})();
